import { render, staticRenderFns } from "./bottom-left.vue?vue&type=template&id=04ea488a&"
import script from "./bottom-left.vue?vue&type=script&lang=js&"
export * from "./bottom-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports